import { action } from 'typesafe-actions';
import { asyncAction } from 'store/utils/promiseAction';
import {
  CardReceivablesTypes,
  CardTransactionInterface,
  CardPixPaymentInterface,
  CardPaymentHistoryInterface,
} from './types';

// Get Card Pendencies
export const getCardPendenciesRequest = (payload: {
  cardNumber: string;
  expirationDate: string;
}) => asyncAction(CardReceivablesTypes.GET_CARD_PENDENCIES_REQUEST, payload);
export const getCardPendenciesSuccess = (payload: {
  cardNumber: string;
  transactionsList: CardTransactionInterface[];
}) => action(CardReceivablesTypes.GET_CARD_PENDENCIES_SUCCESS, payload);
export const getCardPendenciesFailure = () =>
  action(CardReceivablesTypes.GET_CARD_PENDENCIES_FAILURE);

// Generate Card Payment
export const generateCardPaymentRequest = (payload: {
  cardNumber: string;
  transactionIds: string[];
}) => asyncAction(CardReceivablesTypes.GENERATE_CARD_PAYMENT_REQUEST, payload);
export const generateCardPaymentSuccess = (payload: {
  pixPayment: CardPixPaymentInterface;
}) => action(CardReceivablesTypes.GENERATE_CARD_PAYMENT_SUCCESS, payload);
export const generateCardPaymentFailure = () =>
  action(CardReceivablesTypes.GENERATE_CARD_PAYMENT_FAILURE);

// Get Card Payment History
export const getCardHistoryRequest = (payload: {
  cardNumber: string;
  expirationDate: string;
}) => asyncAction(CardReceivablesTypes.GET_CARD_HISTORY_REQUEST, payload);
export const getCardHistorySuccess = (payload: {
  historyList: CardPaymentHistoryInterface[];
}) => action(CardReceivablesTypes.GET_CARD_HISTORY_SUCCESS, payload);
export const getCardHistoryFailure = () =>
  action(CardReceivablesTypes.GET_CARD_HISTORY_FAILURE);

// Refresh Card Payment Status
export const refreshCardPaymentRequest = (payload: { paymentId: string }) =>
  asyncAction(CardReceivablesTypes.REFRESH_CARD_PAYMENT_REQUEST, payload);
export const refreshCardPaymentSuccess = (payload: {
  payment: CardPaymentHistoryInterface;
}) => action(CardReceivablesTypes.REFRESH_CARD_PAYMENT_SUCCESS, payload);
export const refreshCardPaymentFailure = () =>
  action(CardReceivablesTypes.REFRESH_CARD_PAYMENT_FAILURE);

// Release Card Payment (manual)
export const releaseCardPaymentRequest = (payload: { paymentId: string }) =>
  asyncAction(CardReceivablesTypes.RELEASE_CARD_PAYMENT_REQUEST, payload);
export const releaseCardPaymentSuccess = (payload: {
  payment: CardPaymentHistoryInterface;
}) => action(CardReceivablesTypes.RELEASE_CARD_PAYMENT_SUCCESS, payload);
export const releaseCardPaymentFailure = () =>
  action(CardReceivablesTypes.RELEASE_CARD_PAYMENT_FAILURE);

// Reset
export const resetCardReceivables = () =>
  action(CardReceivablesTypes.RESET_CARD_RECEIVABLES);
